<template>
  <div v-if="programs.length > 0" class="program-container">
    <div class="is-flex has-text-weight-bold text-grey">
      Programs
    </div>
    <table class="table is-hoverable is-fullwidth">
      <thead>
        <tr>
          <th v-for="(program, index) in programs" :key="index">
            {{ program.programDescription }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(program, index) in programs" :key="index">
            {{ program.studentCount }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['location', 'locationGroupId', 'schoolYear', 'stateId', 'cluster'],
  data() {
    return {
      programs: [],
      tab: null,
    };
  },
  created() {
    if (this.$route.path.includes('election')) {
      this.tab = 'elections';
    } else {
      this.tab = 'population';
    }
  },
  async mounted() {
    await this.getPrograms();
  },
  methods: {
    async getPrograms() {
      try {
        let url = `cep/${this.locationGroupId}/${this.tab}/${this.schoolYear}/program-summaries?`;
        url += this.cluster
          ? `clusterId=${this.stateId}`
          : `schoolId=${this.stateId}`;
        const res = await axios.get(url, {});
        const rows = res.data;
        if (rows && rows.length > 0) {
          rows.forEach((r) => {
            this.programs.push({
              programDescription: r.programDescription,
              studentCount: r.studentCount,
            });
          });
        }
      } catch (error) {
        // handle error
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .program-container
    font-size: 14px
    padding-bottom: .25rem
  .is-flex
    border-bottom: 1px solid #ddd
  .text-grey
    color: #555
</style>
